import * as React from "react"

import ConversationAiControlRow from "./ConversationAiControlRow.tsx"
import ConversationAiPausedBanner from "./ConversationAiPausedBanner.tsx"
import useConversationAiControl from "@hooks/useConversationAiControl.ts"

import { AppStreamChatGenerics } from "@interfaces/IAppStreamChatGenerics.ts"
import { useChannelStateContext } from "stream-chat-react"

const ConversationAiControls: React.FC = () => {
	const { channel } = useChannelStateContext<AppStreamChatGenerics>(
		"ConversationAiControls"
	)

	const {
		state: aiControlState,
		mode: aiControlMode,
		isLoading: isAiControlLoading,
		isSaving: isAiControlSaving,
		isAiEnabled,
		isPausedBannerVisible,
		toggleAiEnabled,
		resumeAi,
	} = useConversationAiControl({
		channel,
		enabled: !!channel,
	})

	const labelKey = aiControlMode
		? isAiEnabled
			? "chat_ai_enabled"
			: "chat_ai_disabled"
		: "chat_ai"

	return (
		<>
			<ConversationAiControlRow
				labelKey={labelKey}
				isLoading={isAiControlLoading && !aiControlMode}
				isSaving={isAiControlSaving}
				isEnabled={isAiEnabled}
				isDisabled={!aiControlMode}
				onToggle={(nextValue) => {
					void toggleAiEnabled(nextValue)
				}}
			/>

			{isPausedBannerVisible && (
				<ConversationAiPausedBanner
					pausedUntil={aiControlState?.pausedUntil}
					disabled={isAiControlSaving}
					onResume={() => {
						void resumeAi()
					}}
				/>
			)}
		</>
	)
}

export default React.memo(ConversationAiControls)
